import {} from "@mui/material";
import type React from "react";
import type { ShipperContractCreatePageProps } from "../model";
import { ContractCreateInProgress } from "./in-progress";
import { ContractCreatePreview } from "./preview";

export const ShipperContractCreatePageUi: React.FC<
  ShipperContractCreatePageProps
> = (props) => {
  if (props.previewValues) {
    return <ContractCreatePreview {...props} />;
  }
  return <ContractCreateInProgress {...props} />;
};
